import { useUserContext } from '@ion/user';

import buildPipelineJson from 'app/pipeline-details/PipelineIntegrationsSection/PipelineIntegrations/DeployModal/buildPipelineJson';
import resolvePipelineConfiguration from 'app/shared/translation/pipelines/resolvePipelineConfiguration';

/**
 * SP - For the moment this is a heavier lift than it needs to be to continue
 *  using the legacy `buildPipelineJSON` behavior
 *
 *  TODO:
 *    - Confirm `compile_pipeline` Action Proxy action is handling all cases
 *      identically to `buildPipelineJSON`
 *    - Add support to `compile_pipeline` Action to:
 *      - Optionally accept an author
 *      - Retain pipeline-level configuration that Ion does not own yet
 */
import { useQueryPipelineWithRoost } from '@ion/api';

export default function useCompilePipeline(pipelineId) {
  const { data, loading } = useQueryPipelineWithRoost({ pipelineId });
  const { user } = useUserContext();

  if (loading) {
    return { loading, compiledPipeline: {}, error: null };
  }

  try {
    const { legacy: pipelineData } = data;

    const {
      pipelineIntegrations: integrations,
      writekey,
      cliManagedIntegrationJson: cliManagedIntegrations,
    } = pipelineData;

    const compiledPipeline = buildPipelineJson({
      pipelineIntegrations: integrations,
      cliManagedIntegrations,
      author: user.email,
      writeKey: writekey,
      pipelineConfiguration: resolvePipelineConfiguration({
        deployedPipeline: pipelineData.deployedPipeline,
        configuredPipeline: pipelineData,
      }),
    });

    return { loading, compiledPipeline, error: null };
  } catch (error) {
    return { loading, compiledPipeline: {}, error };
  }
}
